import React from 'react'

const AuthLayout = ({title,description,children}) => {
  return (
    <div className='w-full h-full md:h-auto min-h-full md:flex flex-col items-center justify-center bg-gradient-to-tr bg-base-bg md:pb-10'>
      
          <div className='h-full md:h-auto border-base w-full md:w-[50%] lg:w-[40%] xl:w-[30%] md:max-w-[500px] px-4 pt-16 pb-10 bg-content-bg md:rounded-[20px] shadow-xl'>
            <img src="/images/influencee.png" className='mx-auto w-[150px] mb-5 '/>
            <h1 className='text-3xl font-bold text-center text-t-light'>
              {title}
            </h1>
            {
              <p className='text-center text-sm text-t-light w-[90%] mx-auto'>
                {description}
              </p>
            }
            {children}
          </div>
    </div>
  )
}

export default AuthLayout